const getControllerStack = (): AbortController[] => {
  const stack = (window as any).abortControllerStack;
  if (Array.isArray(stack)) {
    return stack;
  }

  const globalController = (window as any).myAbortController;
  if (globalController) {
    (window as any).abortControllerStack = [globalController];
    return (window as any).abortControllerStack;
  }

  const controller = new AbortController();
  (window as any).myAbortController = controller;
  (window as any).abortControllerStack = [controller];
  return (window as any).abortControllerStack;
};

export const registerAbortController = (controller: AbortController) => {
  const stack = getControllerStack();
  if (!stack.includes(controller)) {
    stack.push(controller);
  }
};

export const unregisterAbortController = (controller: AbortController) => {
  const stack = getControllerStack();
  (window as any).abortControllerStack = stack.filter((item) => item !== controller);
};

export const abortAllControllersAndReset = () => {
  const stack = getControllerStack();
  const globalController = (window as any).myAbortController;
  const controllers = [...stack];

  if (globalController && !controllers.includes(globalController)) {
    controllers.push(globalController);
  }

  controllers.forEach((controller) => {
    if (controller) {
      controller.abort();
    }
  });

  const newController = new AbortController();
  (window as any).myAbortController = newController;
  (window as any).abortControllerStack = [newController];

  return newController;
};
